import { render, staticRenderFns } from "./InfoCarriesQuote.vue?vue&type=template&id=f38ce7f6&scoped=true"
import script from "./InfoCarriesQuote.vue?vue&type=script&lang=js"
export * from "./InfoCarriesQuote.vue?vue&type=script&lang=js"
import style0 from "./InfoCarriesQuote.vue?vue&type=style&index=0&id=f38ce7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ce7f6",
  null
  
)

export default component.exports